interface ChatbotIconProps {
  size?: number;
  color?: string;
}

export function ChatbotIcon({ size = 24, color = '#ffffff' }: ChatbotIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="9 9 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* 말풍선 */}
      <path
        d="M30.3564 32.8047L29.8049 31.9706L30.2018 31.7081L30.6559 31.8506L30.3564 32.8047ZM33.5771 33.8154L33.2785 34.7698L33.2777 34.7695L33.5771 33.8154ZM34.7812 32.4355L35.6862 32.0101L35.6863 32.0103L34.7812 32.4355ZM33.5449 29.8057L32.6399 30.2311L32.3839 29.6865L32.7452 29.2053L33.5449 29.8057ZM23 10V11C16.3353 11 11 16.1853 11 22.5H10H9C9 15.0076 15.3053 9 23 9V10ZM10 22.5H11C11 28.8147 16.3353 34 23 34V35V36C15.3053 36 9 29.9924 9 22.5H10ZM23 35V34C25.5308 34 27.8727 33.2483 29.8049 31.9706L30.3564 32.8047L30.908 33.6388C28.6558 35.1282 25.9315 36 23 36V35ZM30.3564 32.8047L30.6559 31.8506L33.8766 32.8613L33.5771 33.8154L33.2777 34.7695L30.057 33.7588L30.3564 32.8047ZM33.5771 33.8154L33.8758 32.8611L33.8762 32.8608L34.7812 32.4355L35.6863 32.0103C36.4267 33.586 34.9395 35.2896 33.2785 34.7698L33.5771 33.8154ZM34.7812 32.4355L33.8763 32.861L32.6399 30.2311L33.5449 29.8057L34.4499 29.3802L35.6862 32.0101L34.7812 32.4355ZM33.5449 29.8057L32.7452 29.2053C34.165 27.3139 35 25.0006 35 22.5H36H37C37 25.4562 36.0106 28.1868 34.3447 30.406L33.5449 29.8057ZM36 22.5H35C35 16.1853 29.6647 11 23 11V10V9C30.6947 9 37 15.0076 37 22.5H36Z"
        fill={color}
      />
      {/* 왼쪽 눈 */}
      <ellipse cx="18.5" cy="20" rx="1.5" ry="2" fill={color} />
      {/* 오른쪽 눈 */}
      <ellipse cx="27.5" cy="20" rx="1.5" ry="2" fill={color} />
      {/* 마이크 붐 암 */}
      <path d="M24.5 27H31C33.7614 27 36 24.7614 36 22V21" stroke={color} strokeWidth="2" />
      {/* 마이크 */}
      <rect x="23" y="25" width="6" height="4" rx="2" fill={color} />
    </svg>
  );
}
